import { render, staticRenderFns } from "./production_statistics.vue?vue&type=template&id=10d35063&scoped=true"
import script from "./production_statistics.vue?vue&type=script&lang=js"
export * from "./production_statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d35063",
  null
  
)

export default component.exports